import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DjangoPage} from '../django-paginator';
import {map} from 'rxjs/operators';

interface CompanySearch {
  id: number;
  company_name: string;
  is_partner: boolean;
}

interface EventPartnerStatus {
  partner_category: number;
  company: CompanySearch;
}

export interface CompanyDetails {
  id: number;
  id_company?: number;
  name: string;
  email: string;
  type: string;
  vat_number: string;
  company_number: string;
  address: Address;
  customer_id: string;
  account_manager: AccountManager;
}

export interface Address {
  city: string;
  country: string;
  zip_code: string;
  street: string;
}

export interface AccountManager {
  id: string;
  contact_email: string;
  name: string; // full_name
}

@Injectable()
export class CompanySearchService {
  constructor(private http: HttpClient) {}

  findCompanies = (filter: string) =>
    this.http.get<{results: CompanySearch[]}>(
      `/rest-api/admin-panel/api/v1/admin/companies?name=${encodeURIComponent(filter)}`,
    );

  searchCompanies = params => this.http.get<Companies[]>(`/rest-api/v1/companies/search`, {params});

  findByEvent = (event_id: string) =>
    this.http.get<EventPartnerStatus>(`/rest-api/v1/admin/events/${event_id}/company`);

  details = id => this.http.get<CompanyDetails>(`/rest-api/v1/companies/${id}`);
}
export interface Companies {
  id: number;
  name: string;
}
